import type IFavoriteSaveAssistance from "./favorite-save-assistance.interface";

export function notifyFavoriteSaved(assistance: IFavoriteSaveAssistance) {
    if (assistance.assistActive) assistance.trackSave();
    if (
        assistance.isFirstSaveThisSession() &&
        assistance.assistActive &&
        !assistance.isIntakeComplete()
    ) {
        assistance.sendFirstSave();
    }
}
